import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}trainers/`;

export default {
  getAll(params = {}) {
    return axios.get(API_URL, { params, headers: buildHeaders() });
  },
  get(id) {
    return axios.get(`${API_URL}${id}`, { headers: buildHeaders() });
  },
  
  create(data) {
    // FormData -> let axios set boundary (buildHeaders(..., { multipart: true }))
    return axios.post(API_URL, data, {
      headers: buildHeaders({}, { multipart: true }),
    });
  },
  //   update(id, data) {
  //     return axios.put(`${API_URL}${id}`, data, { headers: buildHeaders() });
  //   },

  update(id, data) {
    const isFD = typeof FormData !== "undefined" && data instanceof FormData;

    if (isFD) {
      // method spoofing for Laravel so PHP parses multipart body
      if (!data.has("_method")) data.append("_method", "PUT");
      return axios.post(`${API_URL}${id}`, data, {
        headers: buildHeaders({}, { multipart: true }),
      });
    }

    // plain JSON updates (no files) can stay real PUT
    return axios.put(`${API_URL}${id}`, data, { headers: buildHeaders() });
  },
  delete(id) {
    return axios.delete(`${API_URL}${id}`, { headers: buildHeaders() });
  },
  bulkDelete(ids) {
    return axios.post(
      `${API_URL}bulk-delete`,
      { ids },
      { headers: buildHeaders() }
    );
  },
};
